export default __webpack_public_path__ + "static/media/upload-document-dark.b01613b3.png";